module.exports = {"харинов":"kharinov","данилина":"danilina","петрова":"petrova","скиевский":"skievskiy","еськин":"eskin","оганнисян":"ogannisy","перекальский":"perekalskiy","балабанцев":"balabantsev","ковалев":"kovalev","кошелев":"koshelev","гордеева":"gordeeva"}


//////////////////
// WEBPACK FOOTER
// ./src/utils/partners.json
// module id = 1524
// module chunks = 0